import { defineComponent as _defineComponent } from 'vue'
import DeliveryAddress from '@/ui/views/myprofile/DeliveryAddress.vue';
import DeliveryAddressViewObject = Vertica.LouisPoulsen.Application.Content.Pages.PartnerPortal.MyProfile.DeliveryAddressViewObject;


export default /*#__PURE__*/_defineComponent({
  __name: 'DeliveryAddresses',
  props: {
    title: { default: '' },
    subtitle: { default: '' },
    deliveryAddresses: null,
    phoneLabel: { default: '' },
    emailLabel: { default: '' }
  },
  setup(__props: any) {



return { __sfc: true,DeliveryAddress }
}

})